import ExpandMore from "@mui/icons-material/ExpandMore";
import { copyLink, linkCopied, openInTab, projects, projectsText, showQr } from "./constants";
import { Container, CopiedIcon, CustomToolTip, Description, LinkOptions, ProjectAccordion, ProjectDetails, ProjectSummary, ProjectText, ProjectsContainer, QrBackDrop, QrContainer } from "./styles";
import { useEffect, useState } from "react";
import { AddBoxOutlined, ContentCopy, QrCodeScanner } from "@mui/icons-material";
import QRCode from "react-qr-code";
const Accordion = ({ link, description, name }) => {
    const [qrCode, setQrCode] = useState('');
    const [tooltip, setTooltip] = useState(copyLink);
    useEffect(() => {
        if (tooltip === linkCopied) {
            setTimeout(() => { setTooltip(copyLink) }, 1000);
        }
    }, [tooltip]);
    const writeToClipboard = (link) => {
        navigator?.clipboard?.writeText(link).then(() => setTooltip(linkCopied)).catch(err => console.log(err));
    };
    return (
        <>
            <ProjectAccordion>
                <ProjectSummary expandIcon={<ExpandMore />}>{name}</ProjectSummary>
                <ProjectDetails>
                    <Description>{description}</Description>
                    {link && <LinkOptions>
                        <CustomToolTip title={tooltip} arrow placement="top">
                            {tooltip === copyLink ? <ContentCopy onClick={() => writeToClipboard(link)} /> : <CopiedIcon />}
                        </CustomToolTip>
                        <CustomToolTip title={openInTab} arrow placement="top">
                            <AddBoxOutlined onClick={() => window.open(link)} />
                        </CustomToolTip>
                        <CustomToolTip title={showQr} arrow placement="top">
                            <QrCodeScanner onClick={() => setQrCode(link)} />
                        </CustomToolTip>
                    </LinkOptions>}
                </ProjectDetails>
            </ProjectAccordion>
            <QrBackDrop open={!!qrCode} onClick={() => setQrCode('')}>
                {qrCode && <QrContainer>
                    <QRCode value={qrCode} />
                </QrContainer>}
            </QrBackDrop>
        </>
    );
};
export default function Projects() {
    return (
        <Container id="PROJECTS">
            <ProjectText>{projectsText}</ProjectText>
            <ProjectsContainer>
                {projects.map((eachProject, index) => {
                    return (
                        <Accordion key={index} {...eachProject} />
                    );
                })}
            </ProjectsContainer>
        </Container>
    );
}